import { registerSplashBtns } from '../../js/splash-btn-service';
// import { metaService } from '../../js/meta-service';

const apiOrigin = document.querySelector('meta[name="api-origin"]')?.content;

let splashBtns = [];

function initSplashBtns() {
  splashBtns = document.querySelectorAll('.splash-btn');

  registerSplashBtns(splashBtns);
}

window.addEventListener('message', (event) => {
  const iframeWindow = event.source;
  const iframes = document.querySelectorAll('iframe');
  const iframe = Array.from(iframes).find(iframe => iframe.contentWindow === iframeWindow);

  if (event.origin === apiOrigin && iframe) {
    const height = Number(event.data.height);
    if (!isNaN(height)) {
      iframe.setAttribute('height', 30 + height);
    } else {
      console.warn('Invalid height received', event.data);
    }
  }
}, false);

// metaService.setWebsiteMeta(); // TODO: move to template (actual for SSR only)

addEventListener('DOMContentLoaded', () => {
  initSplashBtns();
});
